<template>
<div class="row m-0 pt-1 px-1 px-xl-0">
	<half-line-vidget 
		:name="`${Breaker.settingNames[Breaker.passportKeys.breakerMode]}`"
		:value="breakerModeText(breaker?.getMetricValue(Breaker.passportKeys.breakerMode))"
	/>
</div>
<div class="row m-0 pt-1 px-1 px-xl-0">
	<!-- <div class="row col px-0 mx-0 g-0"> -->
	<half-line-vidget 
		:name="`${Breaker.settingNames[Breaker.passportKeys.currentOnDuration]} (цільова)`"
		:value="breaker?.getMetricValue(Breaker.passportKeys.currentOnDuration)"
	/>
	<!-- </div> -->
</div>
<div class="row m-0 pt-1 px-1 px-xl-0">
	<half-line-vidget 
		:name="`${Breaker.settingNames[Breaker.passportKeys.currentOffDuration]} (цільова)`"
		:value="breaker?.getMetricValue(Breaker.passportKeys.currentOffDuration)"
	/>
</div>
</template>


<script>
import HalfLineVidget from "@/components/Vidgets/HalfLineVidget.vue"
import { Breaker } from "@/models/breaker.js"
import { useAccontStore } from '@/stores/AccountStore.js'
import { useStationsStore } from '@/stores/StationsStore.js'
import { Station } from '@/models/station.js'

export default {
	components: {
		HalfLineVidget,
	},

	props: {
		stationId: {
			type: String,
			require: true,
		},
	},

	setup() {
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()

		return {
			accountStore,
			stationsStore,
			Station,
			Breaker,
		}
	},

	data() {
		return {}
	},

	async created() {},

	mounted() {},

	methods: {
		breakerModeText(value) {
			const mode = Breaker.breakerModes.find(el => el.value == value)
			return mode ? mode.text : '-'
		}
	},

	computed: {
		station() { return this.stationsStore.station(this.stationId) },
		
		breaker() { return this.stationsStore.station(this.stationId).breaker },
	},
}
</script>


<style src="@/assets/widget.css" scoped></style>
<style scoped>
</style>